import React from "react";
import Button from "../Button/Button";
import "./EmptyState.css";

/**
 * Empty-state block — zero-games, empty-filter, and future blank surfaces.
 * Composes Button. Surface-aware. (No MUI equivalent.)
 *
 * Props:
 *   icon, title, body
 *   action / secondaryAction: a React node, or { label, onClick, icon }
 *   bordered: bool — render its own dashed surface (default false; otherwise
 *             meant to sit inside a Card)
 */
const renderAction = (action, variant) => {
  if (!action) return null;
  if (React.isValidElement(action)) return action;
  return (
    <Button variant={variant} startIcon={action.icon} onClick={action.onClick}>
      {action.label}
    </Button>
  );
};

const EmptyState = ({
  icon,
  title,
  body,
  action,
  secondaryAction,
  bordered = false,
  className = "",
}) => (
  <div className={`gx-empty ${bordered ? "is-bordered" : ""} ${className}`}>
    {icon && <div className="gx-empty-icon">{icon}</div>}
    {title && <div className="gx-empty-title">{title}</div>}
    {body && <div className="gx-empty-body">{body}</div>}
    {(action || secondaryAction) && (
      <div className="gx-empty-actions">
        {renderAction(secondaryAction, "secondary")}
        {renderAction(action, "primary")}
      </div>
    )}
  </div>
);

export default EmptyState;
